import React from "react";
import { Form } from "react-bootstrap";

const ExpiryOptions = ({ expiresIn, setExpiresIn, noExpiry, setNoExpiry, isDark }) => {
  const textColor = isDark ? "#f1f1f1" : "#222";
  const borderColor = isDark ? "#444" : "#ccc";
  const bgColor = isDark ? "#2b2b2b" : "#fff";
  const muted = isDark ? "#aaaaaa" : "#666";

  return (
    <div className="mt-4">
      {/* Expires In Section */}
      <div
        className="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-3"
        style={{
          backgroundColor: isDark ? "#1e1e1e" : "#f8f9fa",
          borderRadius: "10px",
          padding: "12px 16px",
          border: `1px solid ${borderColor}`,
        }}
      >
        <div>
          <Form.Label
            className="fw-semibold mb-1"
            style={{ color: textColor, fontSize: "0.95rem" }}
          >
            Link Expires In
          </Form.Label>
          <div style={{ fontSize: "0.8rem", color: muted }}>
            Choose how long your link stays active
          </div>
        </div>

        <Form.Select
          size="sm"
          value={expiresIn}
          onChange={(e) => setExpiresIn(Number(e.target.value))}
          style={{
            backgroundColor: bgColor,
            color: textColor,
            border: `1px solid ${borderColor}`,
            borderRadius: "8px",
            maxWidth: "180px",
            marginTop: "8px",
          }}
        >
          <option value={10}>10 minutes</option>
          <option value={15}>15 minutes</option>
          <option value={30}>30 minutes</option>
          <option value={60}>1 hour</option>
        </Form.Select>
      </div>

      {/* Keep Forever Toggle */}
      <div
        className="d-flex align-items-center justify-content-between p-3 rounded-3"
        style={{
          backgroundColor: isDark ? "#1e1e1e" : "#f8f9fa",
          border: `1px solid ${borderColor}`,
          borderRadius: "10px",
        }}
      >
        <div>
          <Form.Label
            className="fw-semibold mb-1"
            style={{ color: textColor, fontSize: "0.95rem" }}
          >
            Save For Later
          </Form.Label>
          <div style={{ fontSize: "0.8rem", color: muted }}>
            Save once and share it anytime later ✨
          </div>
        </div>

        <Form.Check
          type="switch"
          id="keep-forever"
          checked={noExpiry}
          onChange={(e) => setNoExpiry(e.target.checked)}
          style={{
            transform: "scale(1.2)",
            cursor: "pointer",
          }}
        />
      </div>
    </div>
  );
};

export default ExpiryOptions;
